import PropTypes from 'prop-types';
import React from 'react';
import { BRAND_WOWCHER } from '../../../../config/setup/setup';
import { AUTHENTIC, NEW_DEAL_TODAY } from '../../../../config/text/text';
import { useSocialCues } from '../../../../helpers/deals';
import {
  getBackendSocialCueMessage,
  getRedTextDealSocialCue,
} from '../../../../helpers/socialCues';
import MainDealSocialCue from '../../mainDealSocialCue';

const CalendarSocialCue = ({ deal }) => {
  const socialCuesData = useSocialCues(deal.id);

  return (
    <>
      <MainDealSocialCue
        className="main-deal-social-cue--assure"
        cue={
          deal.display?.bought && deal.totalBought === 0
            ? deal.newdealMessageTag
            : ''
        }
      />
      <MainDealSocialCue
        className="main-deal-social-cue--alert"
        cue={getRedTextDealSocialCue({
          deal,
        })}
        isStarMarked
      />
      <MainDealSocialCue
        className="main-deal-social-cue--assure"
        cue={getBackendSocialCueMessage(socialCuesData)}
      />
      <MainDealSocialCue
        className="main-deal-social-cue--authentic"
        cue={
          deal.display?.previousDeal
            ? AUTHENTIC[process.env.NEXT_PUBLIC_BRAND || BRAND_WOWCHER]
            : ''
        }
      />
    </>
  );
};

CalendarSocialCue.propTypes = {
  deal: PropTypes.object.isRequired,
};

export default CalendarSocialCue;
